import script from "./LearningOutcomeList.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningOutcomeList.vue?vue&type=script&setup=true&lang=js"

import "./LearningOutcomeList.vue?vue&type=style&index=0&id=01c1bd71&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c1bd71"]])

export default __exports__